import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from './context/AuthContext';

function GestionTrabajos() {
    const { token } = useAuth();
    
    const [trabajos, setTrabajos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [mensaje, setMensaje] = useState('');
    
    const [nombreTrabajo, setNombreTrabajo] = useState('');

    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState('');

    const fetchTrabajos = useCallback(async () => {
        setLoading(true);
        try {
            const headers = { 'Authorization': `Bearer ${token}` };
            // --- MODIFICADO ---
            const response = await fetch('/api/trabajos', { headers });
            if (!response.ok) { throw new Error('Error al cargar los trabajos.'); }
            const data = await response.json();
            setTrabajos(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (token) { fetchTrabajos(); }
    }, [token, fetchTrabajos]);

    const handleCrearTrabajo = async (e) => {
        e.preventDefault();
        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/trabajos', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre: nombreTrabajo }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message);
            setMensaje('¡Trabajo creado!');
            setNombreTrabajo('');
            fetchTrabajos();
        } catch (err) {
            setError(err.message);
        }
    };
    
    const handleActualizarTrabajo = async (e) => {
        e.preventDefault();
        try {
            // --- MODIFICADO ---
            const response = await fetch(`/api/trabajos/${editingId}`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre: editingName }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message);
            setMensaje('¡Trabajo actualizado!');
            setEditingId(null);
            fetchTrabajos();
        } catch (err) {
            setError(err.message);
        }
    };

    const handleDesactivarTrabajo = async (trabajoId) => {
        if (window.confirm('¿Seguro que quieres desactivar este tipo de trabajo?')) {
            try {
                // --- MODIFICADO ---
                const response = await fetch(`/api/trabajos/${trabajoId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await response.json();
                if (!response.ok) throw new Error(data.message);
                setMensaje('Trabajo desactivado.');
                fetchTrabajos();
            } catch (err) {
                setError(err.message);
            }
        }
    };
    
    const startEditing = (trabajo) => {
        setEditingId(trabajo.id);
        setEditingName(trabajo.nombre);
    };
    
    if (loading) return <div className="text-center mt-5"><div className="spinner-border"></div></div>;

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <h2 className="mb-4">Gestionar Tipos de Trabajo</h2>
                    
                    {error && <div className="alert alert-danger">{error}</div>}
                    {mensaje && <div className="alert alert-success">{mensaje}</div>}

                    <div className="card shadow-sm mb-4">
                        <div className="card-body">
                            <h5 className="card-title">Crear Nuevo Tipo de Trabajo</h5>
                            <form onSubmit={handleCrearTrabajo}>
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Nombre del nuevo trabajo" value={nombreTrabajo} onChange={(e) => setNombreTrabajo(e.target.value)} required />
                                    <button className="btn btn-primary" type="submit">Crear</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="list-group">
                        {trabajos.map(trabajo => (
                            <div key={trabajo.id} className="list-group-item">
                                {editingId === trabajo.id ? (
                                    <form onSubmit={handleActualizarTrabajo} className="d-flex gap-2">
                                        <input type="text" className="form-control" value={editingName} onChange={(e) => setEditingName(e.target.value)} required />
                                        <button type="submit" className="btn btn-success btn-sm">Guardar</button>
                                        <button type="button" onClick={() => setEditingId(null)} className="btn btn-secondary btn-sm">Cancelar</button>
                                    </form>
                                ) : (
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            {trabajo.nombre}
                                            
                                        </div>
                                        <div>
                                            <span className={`badge rounded-pill ms-2 ${trabajo.activo ? 'bg-success' : 'bg-secondary'}`}>
                                                {trabajo.activo ? 'Activo' : 'Inactivo'}
                                            </span>
                                            <button onClick={() => startEditing(trabajo)} className="btn btn-outline-primary btn-sm me-1">Editar</button>
                                            {trabajo.activo && <button onClick={() => handleDesactivarTrabajo(trabajo.id)} className="btn btn-outline-danger btn-sm">Desactivar</button>}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GestionTrabajos;